import React from "react";
import { Card, Table } from "antd";
import { Task } from "../tasks";
import { CARD_CONFIG } from "../config";

interface TasksTableProps {
  tasks: Task[];
  tasksColumns: any[];
}

export const TasksTable: React.FC<TasksTableProps> = ({
  tasks,
  tasksColumns,
}) => {
  return (
    <Card title={CARD_CONFIG.tasks.title}>
      <Table
        dataSource={tasks}
        columns={tasksColumns}
        rowKey="name"
        pagination={false}
        size="small"
      />
    </Card>
  );
};
